<template>
    <div class="hero-prompt">
        <div class="hero-prompt-content">
            <div class="hero-prompt-brand">
                <v-icon icon="fa-solid fa-robot" size="20" aria-hidden="true" />
                <span>GENERIO AGENT</span>
            </div>

            <h1>What 3D model would you like to generate?</h1>
            <p class="hero-prompt-description">Add reference images for better results.</p>

            <PromptInput
                :model-value="modelValue"
                :attachments="attachments"
                :busy="busy"
                @update:model-value="$emit('update:modelValue', $event)"
                @add-files="$emit('add-files', $event)"
                @remove-file="$emit('remove-file', $event)"
                @submit="$emit('submit')" />
        </div>
    </div>
</template>

<script>
import PromptInput from '../prompt/PromptInput.vue'

export default {
    name: 'HeroPrompt',
    components: { PromptInput },
    props: {
        modelValue: { type: String, default: '' },
        busy: { type: Boolean, default: false },
        attachments: { type: Array, default: () => [] }
    },
    emits: ['update:modelValue', 'add-files', 'remove-file', 'submit']
}
</script>

<style scoped>
.hero-prompt {
    flex: 1;
    display: grid;
    place-items: center;
    padding: 64px 24px;
}

.hero-prompt-content {
    width: 100%;
    max-width: 800px;
    text-align: center;
}

.hero-prompt-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 28px;
    color: rgb(var(--v-theme-color1));
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
}

h1 {
    max-width: 680px;
    margin: 0 auto;
    font-size: clamp(30px, 4vw, 48px);
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.035em;
    text-wrap: balance;
}

.hero-prompt-description {
    margin: 20px 0 36px;
    color: rgb(var(--v-theme-secondary));
    font-size: 15px;
    line-height: 1.6;
}

@media (max-width: 600px) {
    .hero-prompt {
        padding: 40px 16px;
    }

    .hero-prompt-description {
        margin-bottom: 28px;
        font-size: 14px;
    }
}
</style>
